import axios from 'axios';
// Local
//  const baseURL = 'http://localhost:9927/api/';

// Testing 
// const baseURL='http://targettest.asktek.net/tompg.majestic.office.webapi/api/'

// Demo 
const baseURL='http://targetdemo.asktek.net/tompg.majestic.office.webapi/api/'

// live 
// const baseURL="https://live.asktek.net/buroneed_webapi/api/"

// Majestic office demo
// const baseURL='http://targetdemo.asktek.net/tompg.majestic.office.webapi/api/'

// Elite demo
// const baseURL='http://targetdemo.asktek.net/tompg.elite.work.store.india.webapi/api/'

// New Server 
// const baseURL='http://103.191.132.124/tompg.majestic.office.webapi/api/'



const instance = axios.create({
  baseURL,
});

export default {
  instance,
  baseURL,
};
